var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2892 9.5L11.2024 3.82746C10.9272 3.63449 10.9334 3.32585 11.2162 3.1381C11.4989 2.95034 11.9511 2.95457 12.2262 3.14754L20.7976 9.16005C21.0675 9.34927 21.0675 9.65074 20.7976 9.83995L12.2262 15.8525C11.9511 16.0454 11.4989 16.0497 11.2162 15.8619C10.9334 15.6742 10.9272 15.3655 11.2024 15.1726L19.2892 9.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2892 9.5L2.20238 3.82746C1.92723 3.63449 1.93342 3.32585 2.21619 3.1381C2.49895 2.95034 2.95114 2.95457 3.22619 3.14754L11.7976 9.16005C12.0675 9.34927 12.0675 9.65074 11.7976 9.83995L3.22619 15.8525C2.95114 16.0454 2.49895 16.0497 2.21619 15.8619C1.93342 15.6742 1.92723 15.3655 2.20238 15.1726L10.2892 9.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigate);
export default __webpack_public_path__ + "static/media/navigate.2b96041b7b7c2bcec29a26eb0e549479.svg";
export { ForwardRef as ReactComponent };